import {
  transformNumber,
  transformIntegerNumber,
} from "@king-ict/eupisi-ui/utils";
import { TFunction } from "i18next";
import * as yup from "yup";

export interface LocationProgramDataValidationSchemaProps {
  t: TFunction;
}

export const LocationProgramDataValidationSchema = ({
  t,
}: LocationProgramDataValidationSchemaProps) => {
  const requiredMsg = t("validations.required");
  const capacityMsg = t("locationProgramDetails.capacityValidation");
  const priceMsg = t("locationProgramDetails.priceValidation");
  const durationMsg = t("locationProgramDetails.durationValidation");

  return yup.object().shape({
    locationId: yup
      .number()
      .nullable()
      .min(1, requiredMsg)
      .required(requiredMsg),
    locationProgramId: yup
      .number()
      .nullable()
      .min(1, requiredMsg)
      .required(requiredMsg),
    locationDescription: yup.string().nullable(),
    programDescription: yup.string().nullable(),
    note: yup.string().nullable(),
    workOrganizationId: yup.number().required(requiredMsg),
    capacity: yup
      .number()
      .transform(transformIntegerNumber)
      .min(1, capacityMsg)
      .max(1000, capacityMsg)
      .required(capacityMsg),
    duration: yup
      .number()
      .transform(transformNumber)
      .min(1, durationMsg)
      .max(18, durationMsg)
      .required(durationMsg),
    price: yup
      .number()
      .transform(transformNumber)
      .min(0, priceMsg)
      .max(99000, priceMsg)
      .required(priceMsg),
  });
};
